import { Spin } from 'antd';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { useCoursesCategory } from 'modules/courses/hooks';
import { setCategoryIds, setMethod, setSort, setType } from 'modules/courses/store';

import { Select } from './select-filter';

interface IProps {
  selectClassName?: string;
  dropDownClassName?: string;
  maxVisibleTags?: number;
}

const SortsSelect: React.FC<IProps> = ({ selectClassName, dropDownClassName, maxVisibleTags }) => {
  const t = useTranslations();
  const dispatch = useAppDispatch();
  const { type, method, sort, categoryIds } = useAppSelector(({ courses }) => ({
    type: courses?.type,
    method: courses?.method,
    sort: courses?.sort,
    categoryIds: courses?.categoryIds
  }));
  const { coursesCategory, isLoading } = useCoursesCategory();

  const options = [
    { label: 'Free + Pro', value: 'both' },
    { label: 'Free', value: 'free' },
    { label: 'Pro', value: 'premium' }
  ];
  const TypeOptions = [
    { label: t('kurslar'), value: 'courses' },
    { label: t('ustozlar'), value: 'teachers' }
  ];
  const SortOptions = [
    { label: t('barchasi'), value: 'all' },
    { label: t('mashxur_kurslar'), value: 'popular' },
    { label: t('yangi_kurslar'), value: 'new' }
  ];
  const categories = coursesCategory?.map(item => ({
    label: item?.name,
    value: item?.id
  }));

  return (
    <>
      <Spin spinning={isLoading}>
        <Select
          options={categories}
          value={categoryIds}
          onChange={val => dispatch(setCategoryIds(val as number[]))}
          placeholder={t('Kategoriya')}
          multiple
          className={selectClassName}
          maxVisibleTags={maxVisibleTags}
          dropDownClassName={dropDownClassName}
          disabled={type === 'teachers'}
        />
      </Spin>
      <Select
        options={SortOptions}
        value={sort}
        onChange={val => dispatch(setSort(val as string))}
        placeholder={t('turi')}
        className={selectClassName}
        dropDownClassName={dropDownClassName}
        disabled={type === 'teachers'}
      />
      <Select
        options={TypeOptions}
        value={type}
        onChange={val => dispatch(setType(val as string))}
        placeholder={t('turi')}
        className={selectClassName}
        dropDownClassName={dropDownClassName}
      />
      <Select
        options={options}
        value={method}
        disabled={type === 'teachers'}
        onChange={val => dispatch(setMethod(val as string))}
        placeholder={t('kurslar_turi')}
        className={selectClassName}
        dropDownClassName={dropDownClassName}
      />
    </>
  );
};

export default SortsSelect;
